export default __webpack_public_path__ + "static/media/Private-5g_Customer-Story-Aircraft.06fc2e3d.jpg";